import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { SystemStatus } from 'src/app/shared/models/system-status.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private systemPath: string = `${environment.apiBasePath}${environment.systemPath}`;
  private systemStatus$: BehaviorSubject<Partial<SystemStatus>> = new BehaviorSubject<Partial<SystemStatus>>({});

  public currentSystemStatus: Observable<Partial<SystemStatus>> = this.systemStatus$.asObservable();

  constructor(private http: HttpClient) {}

  public updateSystemStatus(status: boolean): Observable<boolean> {
    const toggleStatus = status ? 'enable' : 'disable';
    return this.http.post<boolean>(`${this.systemPath}/status/${toggleStatus}`, {});
  }

  public checkSystemStatus(): Observable<SystemStatus> {
    return this.http.get<SystemStatus>(`${this.systemPath}/status`).pipe(
      tap((value) => {
        this.updateLocalSystemStatus(value);
      })
    );
  }

  private updateLocalSystemStatus(systemStatus: Partial<SystemStatus>) {
    this.systemStatus$.next(systemStatus);
  }
}
